import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "../../common/archive/ArchiveHeader.module.scss";

type Props = {
  titles: [string, string];
  isNormalArchive: boolean;
  handleArchiveType: (isNormalArchive: boolean) => void;
};
const SwitchListButton: React.FC<Props> = ({
  titles,
  isNormalArchive,
  handleArchiveType,
}) => {
  return (
    <>
      <div
        className={styles["switch-type"]}
        onClick={() => handleArchiveType(!isNormalArchive)}
      >
        <FontAwesomeIcon icon={["fal", "arrows-rotate"]} />
        {isNormalArchive ? titles[1] : titles[0]}
      </div>
    </>
  );
};

export default SwitchListButton;
